var player;

class IoYoutube {

    static showVideo(target) {
        const yt_id = target.dataset.ytid;

        if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function() {
                IoYoutube.onYouTubePlayer(yt_id);
            };
        } else {
            IoYoutube.onYouTubePlayer(yt_id);
        }
    }

    static onYouTubePlayer(video_id) {
        player = new YT.Player('player', {
            videoId: video_id,
            width: '100%',
            events: {
                'onReady': IoYoutube.onPlayerReady,
            }
        });
    }

    static onPlayerReady(event) {
        // player pronto
    }
}

export default IoYoutube;
